import React from 'react';
import Style from '../../Styles/DashboardStyle.module.css';

const TextInput = ({ label, id, value, onChange, type = "text", errorMessage }) => (
    <div className={Style.group}>
        <label htmlFor={id}>{label}</label>
        <input className={Style.fromControl} id={id} name={id} type={type} value={value} onChange={onChange} />
        {errorMessage && <span className={`${Style.fieldValidationValid} ${Style.textDanger}`} data-valmsg-for={id} data-valmsg-replace="true">{errorMessage}</span>}
    </div>
);

export default TextInput;